import { render, staticRenderFns } from "./bill_payments.vue?vue&type=template&id=37632854&scoped=true&"
import script from "./bill_payments.vue?vue&type=script&lang=js&"
export * from "./bill_payments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37632854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37632854')) {
      api.createRecord('37632854', component.options)
    } else {
      api.reload('37632854', component.options)
    }
    module.hot.accept("./bill_payments.vue?vue&type=template&id=37632854&scoped=true&", function () {
      api.rerender('37632854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/user/profile/tabs/billing_components/bill_payments.vue"
export default component.exports